import React, { useCallback } from 'react';
import { MagnifyingGlass as SearchIcon, CloseIcon } from '@td-client-frontend/icons';
import clsx from 'clsx';

interface Props {
  focused: boolean;
  loading: boolean;
  value: string;
  onClick: (action: SearchAction) => void;
}

export enum SearchAction {
  CLEAR,
  SUBMIT
}

export function SearchActionButton({ value, focused, onClick, loading }: Props) {
  const submit = useCallback(() => {
    onClick(SearchAction.SUBMIT);
  }, [onClick]);

  const clear = useCallback(() => {
    onClick(SearchAction.CLEAR);
  }, [onClick]);

  const SearchClearButton = (
    <button
      className="flex items-center px-4  self-stretch h-full bg-white focus:outline-none focus-visible:shadow-outline disabled:opacity-50"
      onClick={clear}
      data-testid="clearButton"
      aria-label="Remove search string"
    >
      <CloseIcon title="clearButton" className="fill-black w-4" />
    </button>
  );

  const SearchSubmitButton = (
    <button
      className={clsx(
        'flex items-center px-4 self-stretch h-full focus:outline-none focus-visible:ring disabled:opacity-50 bg-white'
      )}
      data-testid="searchButton"
      aria-label="Search Groups"
      onClick={submit}
      disabled={loading}
    >
      <SearchIcon title="searchIcon" aria-hidden />
    </button>
  );

  return <>{value.length >= 3 ? SearchClearButton : SearchSubmitButton}</>;
}
